<h3 style="font-size: 16px; font-weight: 500">{{'book_contents_title' | translate}}</h3>
<quill-view [content]="bookContents"></quill-view>
